import AmazonChatIcon from './AmazonChatIcon.component';
export default AmazonChatIcon;